module.exports = __webpack_public_path__ + "static/media/video2.6ba8540e.mp4";